import React, { useContext, useEffect } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import AuthContext from "../../context/auth/AuthContext";
// import BlankPage from "../layout/BlankPage";
import useTokenCheck from "../../hooks/useTokenCheck";

const PrivateRoute = ({
  component: Component,
  resetUseIdleTimer,
  appTitle,
  mainContentRef,
  match,
  ...rest
}) => {
  const authContext = useContext(AuthContext);
  const location = useLocation();

  const { isAuthenticated, isValidating } = authContext;

  const { hasTokenExpired } = useTokenCheck();
  useEffect(() => {
    // clearAlerts();
    console.log("Path Changed:", rest.path);
    console.log("isLoggedIn:", isAuthenticated);
    console.log("isValidating:", isValidating);
    console.log("location:", location);

    async function asyncEffect() {
      if (isAuthenticated) {
        await hasTokenExpired();
      }
    }
    asyncEffect();
    //eslint-disable-next-line
  }, [rest.path]);

  return (
    <Route
      {...rest}
      render={(props) =>
        !isAuthenticated ? (
          <Redirect to="/" />
        ) : (
          <Component
            {...props}
            resetUseIdleTimer={resetUseIdleTimer}
            appTitle={appTitle}
            mainContentRef={mainContentRef}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
